/* eslint-disable react-hooks/exhaustive-deps */
import { Block, BorderHorizontal, BorderOuter, BorderVertical, Close, ExpandMore, FormatAlignCenter, FormatAlignLeft, FormatAlignRight, GridOn, Image, Opacity, Palette, Save, TableRows, TextFields, ViewColumn } from '@mui/icons-material';
import { LoadingButton } from '@mui/lab';
import { Accordion, AccordionDetails, AccordionSummary, Box, Button, Divider, FormControl, FormControlLabel, InputLabel, MenuItem, Select, SelectChangeEvent, Slider, Switch, ToggleButton, Typography } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { useEffect, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { StyledToggleButtonGroup } from '../../Components/ButtonGroup';
import { ColorInput } from '../../Components/ColorInput';
import DialogQuiz from '../../Components/Modal/DialogQuiz';
import { StyledTextField } from '../../Components/TextInput';
import { toSentenceCase } from '../../Util/stringUtils';
import { Template } from '../../Model/TemplateModel';
import { useFindAllMediaQuery } from '../../service/MediaService';
import { useFindAllPriceTablesQuery } from '../../service/PriceTableService';
import { useCreateTemplateMutation, useUpdateTemplateMutation } from '../../service/TemplateService';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { useSyncPriceTables } from '../Products/useSyncPriceTables';
import { setPageTitle } from '../../store/reducers/ui';
import TemplatePreView from './TemplatePreView';
type Props = {}

const initialTemplate: Template = {
  id: undefined,
  userId: undefined,
  name: 'Novo Template',
  rows: 15,
  columns: 2,

  //colors
  color1: '#121c29',
  color2: '#ff7600',
  textColor: '#fff',
  priceColor: '#f98700',
  isTranslucid: false,
  translucid: 1,
  isStriped: false,

  //text
  textSize: 10,
  textPos: 'left',
  pricePos: 'left',
  cipherPos: 'left',
  cipher: 'R$',
  showName: false,

  //image
  haveImage: false,
  imagePos: 3,
  image: undefined,
  haveBackground: false,
  background: undefined,
  imageSize: 3,

  //grid
  haveGrid: false,
  grid: ['all'],
  gridColor: '#000000',
  isDefault: false,

  //destaque (promoção)
  highlightColor1: '#7a1f1f',
  highlightColor2: '#a83232',
  highlightTextColor: '#ffffff',
  highlightPriceColor: '#ffd166',
  highlightIsTranslucid: false,
  highlightTranslucid: 100,
  highlightIsStriped: false,
  highlightTextSize: 10
}

const TemplateEditPage = (props: Props) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { id = null } = useParams();

  // Redux hooks
  const user = useAppSelector(state => state.auth.user);
  const playlists = useAppSelector(state => state.playlist);
  const priceTable = useAppSelector(state => state.priceTable);
  const templates = useAppSelector(state => state.template);
  const medias = useAppSelector(state => state.media);
  const syncPriceTables = useSyncPriceTables();

  // State hooks
  const [selectedTable, setSelectedTable] = useState<number | undefined>(undefined);
  const [error, setError] = useState<string | undefined>();
  const [openDialog, setOpenDialog] = useState(false);
  const [template, setTemplate] = useState<Template>(initialTemplate);
  const [isAdmin, setIsAdmin] = useState(false)
  const [expandedSection, setExpandedSection] = useState<'imagem' | 'grade' | false>(false)
  const oldName = useRef("")

  // API hooks
  useFindAllPriceTablesQuery(user?.id?.toString() || '', { skip: priceTable.length > 0 });
  useFindAllMediaQuery(user?.id?.toString() || '', { skip: medias.length > 0 });
  const [createTemplate, { isLoading: isCreating }] = useCreateTemplateMutation();
  const [updateTemplate, { isLoading: isUpdating }] = useUpdateTemplateMutation();

  useEffect(() => {
    if (priceTable.length > 0) {
      setSelectedTable(priceTable[0].id ?? undefined)
    }
  }, [])

  useEffect(() => {
    dispatch(setPageTitle(template.name || 'Novo Template'))
  }, [template.name])

  useEffect(() => {
    function setExistingTemplate(pageId: string) {
      const selected = templates.find((t => t.id === Number(pageId)))
      if (selected) {
        const image = selected.image
        const background = selected.background
        const selectedImage = image ? medias.find(m => m.id === image.id) : undefined
        const selectedBackground = background ? medias.find(m => m.id === background.id) : undefined
        setTemplate({
          ...initialTemplate,
          ...selected,
          // campos de destaque podem ser null em templates antigos (antes da migração do banco)
          highlightColor1:      selected.highlightColor1      ?? initialTemplate.highlightColor1,
          highlightColor2:      selected.highlightColor2      ?? initialTemplate.highlightColor2,
          highlightTextColor:   selected.highlightTextColor   ?? initialTemplate.highlightTextColor,
          highlightPriceColor:  selected.highlightPriceColor  ?? initialTemplate.highlightPriceColor,
          highlightTranslucid:  selected.highlightTranslucid  ?? initialTemplate.highlightTranslucid,
          highlightTextSize:    selected.highlightTextSize     ?? selected.textSize,
          image: selectedImage,
          background: selectedBackground,
        })
        oldName.current = selected.name;
      }
    }

    if (id && medias.length > 0 && id !== "novo") {
      setExistingTemplate(id)
    }
  }, [id, medias])

  useEffect(() => {
    if (user) {
      setIsAdmin(user.role === "ADMIN")
    }
  }, [user])



  async function handleCloseDialog(option: boolean) {
    setOpenDialog(false);
    if (option) navigate("/templates")
  }
  function validadeTemplate(template: Template) {
    if (template.name.trim() !== "") {
      if (template.name.length > 3) {
        if (id && template.name === oldName.current) {
          return true
        } else {
          if (!templates.some((t) => t.name === template.name)) {
            setError(undefined)
            return true
          } else setError("Nome já existe")
        }
      } else setError("Nome muito curto")
    } else setError("Insira um nome")
    return false
  }

  async function handleSave() {
    if (validadeTemplate(template)) {
      setError(undefined)
      let gridstr: string = ""
      if (Array.isArray(template.grid) && template.grid.every(item => typeof item === 'string'))
        gridstr = template.grid.join(",")
      const userId = user?.id
      if (template.id) {
        await updateTemplate({
          template: {
            ...template,
            grid: gridstr,
            image: template.image?.id,
            background: template.background?.id,
          }
        })
          .unwrap()
          .then(async () => {
            toast.success("Template Atualizado")
            const affectedIds = new Set<number>()
            for (const playlist of playlists) {
              for (const item of playlist.items) {
                if (item.type === 'priceTable' && item._templateId === template.id && item._priceTableId) {
                  affectedIds.add(item._priceTableId)
                }
              }
            }
            if (affectedIds.size > 0) await syncPriceTables(affectedIds)
            navigate("/templates")
          })
          .catch(() => { toast.error("Falha ao atualizar template"); })
      } else {

        await createTemplate({
          template: {
            ...template,
            userId,
            grid: gridstr,
            image: template.image?.id,
            background: template.background?.id,
            isDefault: isAdmin
          }
        })
          .unwrap()
          .then(() => {
            toast.success("Template criado")
            navigate("/templates")
          })
          .catch(() => { toast.error("Falha ao criar template"); })
      }
    }
  }

  function handleTextPosition(_: any, txtPosition: string | null) {
    if (txtPosition) setTemplate(prev => ({ ...prev, textPos: txtPosition }))
  };
  function handleCipher(_: any, cipher: string) {
    if (cipher || '') setTemplate(prev => ({ ...prev, cipher: cipher }))
  }
  function handleGrid(_: any, grid: string[]) {
    setTemplate(prev => ({ ...prev, grid: grid }))
  }

  function handleImage(e: SelectChangeEvent<number>) {
    const image = medias.find(m => m.id === e.target.value)
    if (image) {
      setTemplate(prev => ({ ...prev, image }))
    }
  }
  function handleBackground(e: SelectChangeEvent<number>) {
    const background = medias.find(m => m.id === e.target.value)
    if (background) {
      setTemplate(prev => ({ ...prev, background }))
    }
  }

  function handleHaveBackground(haveBackground: boolean) {
    if (haveBackground) {
      setTemplate(prev => ({ ...prev, isTranslucid: true }))
    }
    setTemplate(prev => ({ ...prev, haveBackground }))
  }

  return (
    <>
      <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1, minHeight: 0, overflow: 'hidden' }}>
        <DialogQuiz title={"Tem certeza?"}
          text={"Todas as modificações não salvas serão perdidas!"}
          open={openDialog} handleClose={handleCloseDialog}
          variant="warning" />
        <Box id="container" sx={{ display: 'flex', mt: 1, mx: 2, flex: 1, minHeight: 0 }}>
          <Box id="config" sx={{ display: 'flex', flexDirection: 'column', flex: 4, mr: 1, minHeight: 0 }} >
            <Box sx={{ flex: 1, minHeight: 0, overflowY: 'auto', overflowX: 'hidden', p: 1.5 }}>
            <Grid container width={'100%'} spacing={0.5} alignItems='center' sx={{ alignContent: 'flex-start' }}>
              <Grid size={12}>
                <StyledTextField label='Nome do Template' size='small' value={template.name} type={'text'} onChange={(e) => setTemplate(prev => ({ ...prev, name: toSentenceCase(e.target.value) }))}
                  error={!!error} helperText={error ?? undefined}
                />
              </Grid>

              <Grid size={6}>
                <Typography variant='body2' sx={{ mb: 0.5 }}>Quantidade de Tabelas</Typography>
                <Box display='flex' alignItems='center'>
                  <ViewColumn fontSize='small' sx={{ mr: 1 }} />
                  <Slider value={template.columns} onChange={(e, v) => setTemplate(prev => ({ ...prev, columns: v as number }))} valueLabelDisplay="auto" shiftStep={1} color='secondary' step={1} marks min={1} max={4} />
                </Box>
              </Grid>
              <Grid size={6}>
                <Typography variant='body2' sx={{ mb: 0.5 }}>Quantidade de Itens</Typography>
                <Box display='flex' alignItems='center'>
                  <TableRows fontSize='small' sx={{ mr: 1 }} />
                  <Slider value={template.rows} onChange={(e, v) => setTemplate(prev => ({ ...prev, rows: v as number }))} valueLabelDisplay="auto" shiftStep={1} color='secondary' step={1} marks min={10} max={25} />
                </Box>
              </Grid>

              <Grid size={12}><Divider sx={{ my: 0.25 }} /></Grid>

              <Grid size={12} display='flex' alignItems='center'><TextFields fontSize='small' sx={{ mr: 0.5 }} /><Typography variant='subtitle2'>Textos</Typography></Grid>
              <Grid size={12} display='flex' alignItems='center'><FormControlLabel control={<Switch size='small' checked={template.showName} onChange={() => setTemplate(prev => ({ ...prev, showName: !prev.showName }))} />} label={<Typography variant='body2'>Mostrar nome da tabela</Typography>} /></Grid>
              <Grid size={4} display='flex' alignItems='center'><Typography variant='body2'>Tamanho do texto</Typography></Grid>
              <Grid size={8} display='flex' alignItems='center'>
                <Slider value={template.textSize} onChange={(e, v) => setTemplate(prev => ({ ...prev, textSize: v as number }))} valueLabelDisplay="auto" shiftStep={1} color='secondary' step={1} marks min={1} max={15} />
              </Grid>

              <Grid size={6} display='flex' justifyContent='center'><Typography variant='body2'>Posição do texto</Typography></Grid>
              <Grid size={6} display='flex' justifyContent='center'><Typography variant='body2'>Cifrão</Typography></Grid>

              <Grid size={6} sx={{ display: 'flex', justifyContent: 'center' }}>
                <StyledToggleButtonGroup size="medium" value={template.textPos} exclusive onChange={handleTextPosition}>
                  <ToggleButton value="left" key="left"><FormatAlignLeft /></ToggleButton>
                  <ToggleButton value="center" key="center"><FormatAlignCenter /></ToggleButton>
                  <ToggleButton value="right" key="right"><FormatAlignRight /></ToggleButton>
                </StyledToggleButtonGroup>
              </Grid>
              <Grid size={6} sx={{ display: 'flex', justifyContent: 'center' }}>
                <StyledToggleButtonGroup size="medium" value={template.cipher} exclusive onChange={handleCipher}>
                  <ToggleButton value="R$" key="left">R$</ToggleButton>
                  <ToggleButton value="$" key="center">$</ToggleButton>
                  <ToggleButton value=" " key="center"><Block /></ToggleButton>
                </StyledToggleButtonGroup>
              </Grid>

              <Grid size={12}><Divider sx={{ my: 0.25 }} /></Grid>

              <Grid size={12} display='flex' alignItems='center'><Opacity fontSize='small' sx={{ mr: 0.5 }} /><Typography variant='subtitle2'>Transparência</Typography></Grid>
              <Grid size={4} display='flex' alignItems='center'>
                <FormControlLabel control={<Switch size='small' checked={template.isTranslucid} onChange={() => setTemplate(prev => ({ ...prev, isTranslucid: !prev.isTranslucid }))} />} label={<Typography variant='body2'>Transparente</Typography>} />
              </Grid>
              <Grid size={8} px={1}>
                <Slider value={template.translucid} onChange={(e, v) => setTemplate(prev => ({ ...prev, translucid: v as number }))} valueLabelDisplay="auto" shiftStep={1} color='secondary' step={5} marks min={0} max={100} disabled={!template.isTranslucid} />
              </Grid>
              <Grid size={12} display='flex' alignItems='center'><FormControlLabel control={<Switch size='small' checked={template.isStriped} onChange={() => setTemplate(prev => ({ ...prev, isStriped: !prev.isStriped }))} />} label={<Typography variant='body2'>Listrado</Typography>} /></Grid>

              <Grid size={12}><Divider sx={{ my: 0.25 }} /></Grid>

              <Grid size={12} display='flex' alignItems='center'><Palette fontSize='small' sx={{ mr: 0.5 }} /><Typography variant='subtitle2'>Cores</Typography></Grid>

              <Grid size={3}>
                <Typography variant='caption' color='text.secondary'>Cor de Fundo</Typography>
                <ColorInput format="hex" value={template.color1} onChange={(e) => setTemplate(prev => ({ ...prev, color1: e }))} />
              </Grid>
              <Grid size={3}>
                <Typography variant='caption' color='text.secondary'>Cor do Texto</Typography>
                <ColorInput format="hex" value={template.textColor} onChange={(e) => setTemplate(prev => ({ ...prev, textColor: e }))} />
              </Grid>
              <Grid size={3}>
                <Typography variant='caption' color='text.secondary'>Cor do Preço</Typography>
                <ColorInput format="hex" value={template.priceColor} onChange={(e) => setTemplate(prev => ({ ...prev, priceColor: e }))} />
              </Grid>
              <Grid size={3}>
                <Typography variant='caption' color='text.secondary'>Cor Secundária</Typography>
                <ColorInput format="hex" value={template.color2} onChange={(e) => setTemplate(prev => ({ ...prev, color2: e }))} />
              </Grid>

              <Grid size={12} sx={{ mt: 0.5 }}>
                <Typography variant='body2' fontWeight={600}>Produto em Destaque</Typography>
              </Grid>
              <Grid size={3}>
                <Typography variant='caption' color='text.secondary'>Fundo Principal</Typography>
                <ColorInput format="hex" value={template.highlightColor1} onChange={(e) => setTemplate(prev => ({ ...prev, highlightColor1: e }))} />
              </Grid>
              <Grid size={3}>
                <Typography variant='caption' color='text.secondary'>Fundo Secundário</Typography>
                <ColorInput format="hex" value={template.highlightColor2} onChange={(e) => setTemplate(prev => ({ ...prev, highlightColor2: e }))} />
              </Grid>
              <Grid size={3}>
                <Typography variant='caption' color='text.secondary'>Cor do Texto</Typography>
                <ColorInput format="hex" value={template.highlightTextColor} onChange={(e) => setTemplate(prev => ({ ...prev, highlightTextColor: e }))} />
              </Grid>
              <Grid size={3}>
                <Typography variant='caption' color='text.secondary'>Cor do Preço</Typography>
                <ColorInput format="hex" value={template.highlightPriceColor} onChange={(e) => setTemplate(prev => ({ ...prev, highlightPriceColor: e }))} />
              </Grid>

              <Grid size={4} display='flex' alignItems='center'><Typography variant='body2'>Tamanho do texto destaque</Typography></Grid>
              <Grid size={8} display='flex' alignItems='center'>
                <Slider value={template.highlightTextSize} onChange={(e, v) => setTemplate(prev => ({ ...prev, highlightTextSize: v as number }))} valueLabelDisplay="auto" shiftStep={1} color='secondary' step={1} marks min={1} max={15} />
              </Grid>

              <Grid size={12}><Divider sx={{ my: 0.25 }} /></Grid>

              <Grid size={12} display='flex' justifyContent='center' alignItems='center'>
                <Accordion sx={{ minWidth: '107%' }} expanded={expandedSection === 'imagem'} onChange={(_, isExp) => setExpandedSection(isExp ? 'imagem' : false)}>
                  <AccordionSummary expandIcon={<ExpandMore />} sx={{ minHeight: 36, '&.Mui-expanded': { minHeight: 36 }, '& .MuiAccordionSummary-content': { my: 0.5 } }}>
                    <Box display='flex' alignItems='center' >
                      <Image fontSize='small' sx={{ mr: 0.5 }} /><Typography variant='subtitle2'>Imagem </Typography>
                    </Box>
                  </AccordionSummary>
                  <AccordionDetails sx={{ pt: 0, pb: 1 }}>
                    <Grid container width={'100%'} spacing={0.5}>
                      <Grid size={6}><FormControlLabel control={<Switch checked={template.haveImage} />} onChange={(e, v) => setTemplate((prev) => ({ ...prev, haveImage: v as boolean }))} label="Imagem lateral" /></Grid>
                      <Grid size={6}>
                        <FormControl size='small' fullWidth><InputLabel >Selecione a imagem</InputLabel>
                          <Select label="Selecione a imagem" MenuProps={{ PaperProps: { style: { maxHeight: "30vh", overflowY: 'auto' } } }}
                            onChange={handleImage}
                            value={template.image?.id || 0}
                            renderValue={(selected) => {
                              const media = medias.find((m) => m.id === selected);
                              return (
                                <Box display="flex" alignItems="center">
                                  <Box
                                    component="img"
                                    src={media?.urlPreview}
                                    sx={{
                                      width: "1.6rem", height: "1.6rem", objectFit: "cover", overflow: "hidden", borderRadius: 1, marginRight: 1
                                    }}
                                  />
                                  <Typography noWrap variant='body1'>{media?.desc}</Typography>
                                </Box>
                              );
                            }}>
                            {medias.map((media) => (
                              <MenuItem value={media.id}>
                                <Box component="img"
                                  src={media.urlPreview}
                                  sx={{ width: "1.8rem", height: "1.8rem", objectFit: "cover", overflow: "hidden", marginRight: 1, borderRadius: 1 }}
                                ></Box><Typography noWrap variant='body1'>{media.desc}</Typography>
                              </MenuItem>
                            ))}

                          </Select>
                        </FormControl>
                      </Grid>
                      <Grid size={4} display='flex' alignItems='center'><Typography variant='body1'>Tamanho da Imagem</Typography></Grid>
                      <Grid size={8} display='flex' alignItems='center'><Slider value={template.imageSize} onChange={(e, v) => setTemplate(prev => ({ ...prev, imageSize: v as number }))} valueLabelDisplay="auto" shiftStep={1} color='secondary' step={1} marks min={1} max={12} /></Grid>
                      <Grid size={4} display='flex' alignItems='center'><Typography variant='body1'>Corte da Imagem</Typography></Grid>
                      <Grid size={8} display='flex' alignItems='center'><Slider value={template.imagePos} onChange={(e, v) => setTemplate(prev => ({ ...prev, imagePos: v as number }))} valueLabelDisplay="auto" shiftStep={1} color='secondary' step={1} marks min={1} max={20} /></Grid>
                      <Grid size={6}><FormControlLabel control={<Switch checked={template.haveBackground} />} onChange={(e, v) => handleHaveBackground(v)} label="Imagem de fundo" /></Grid>
                      <Grid size={6}>
                        <FormControl size='small' fullWidth><InputLabel >Selecione a imagem</InputLabel>
                          <Select label="Selecione a imagem" MenuProps={{ PaperProps: { style: { maxHeight: "30vh", overflowY: 'auto' } } }}
                            value={template.background?.id || 0}
                            onChange={handleBackground}
                            renderValue={(selected) => {
                              const media = medias.find((m) => m.id === selected);
                              return (
                                <Box display="flex" alignItems="center">
                                  <Box
                                    component="img"
                                    src={media?.urlPreview}
                                    sx={{
                                      width: "1.6rem", height: "1.6rem", objectFit: "cover", overflow: "hidden", borderRadius: 1, marginRight: 1
                                    }}
                                  />
                                  <Typography noWrap variant='body1'>{media?.desc}</Typography>
                                </Box>
                              );
                            }}>
                            {medias.map((media) => {
                              return <MenuItem value={media.id}>
                                <Box component="img"
                                  src={media.urlPreview}
                                  sx={{ width: "1.8rem", height: "1.8rem", objectFit: "cover", overflow: "hidden", marginRight: 1, borderRadius: 1 }}
                                ></Box><Typography noWrap variant='body1'>{media.desc}</Typography>
                              </MenuItem>
                            })}

                          </Select>
                        </FormControl>
                      </Grid>
                    </Grid>
                  </AccordionDetails>
                </Accordion>
              </Grid>
              <Grid size={12} display='flex' justifyContent='center' alignItems='center'>
                <Accordion sx={{ minWidth: '107%' }} expanded={expandedSection === 'grade'} onChange={(_, isExp) => setExpandedSection(isExp ? 'grade' : false)}>
                  <AccordionSummary expandIcon={<ExpandMore />} sx={{ minHeight: 36, '&.Mui-expanded': { minHeight: 36 }, '& .MuiAccordionSummary-content': { my: 0.5 } }}>
                    <Box display='flex' alignItems='center' >
                      <GridOn fontSize='small' sx={{ mr: 0.5 }} /><Typography variant='subtitle2'>Grade </Typography>
                    </Box>
                  </AccordionSummary>
                  <AccordionDetails sx={{ pt: 0, pb: 1 }}>
                    <Grid container width={'100%'} spacing={0.5} display='flex' alignItems='center'>
                      <Grid size={6}  ><FormControlLabel control={<Switch checked={template.haveGrid} onChange={(e, v) => setTemplate(prev => ({ ...prev, haveGrid: !prev.haveGrid }))} />} label="Mostrar grade" /></Grid>
                      <Grid size={6} sx={{ display: 'flex', justifyContent: 'end' }}>
                        <StyledToggleButtonGroup size="medium" value={template.grid} disabled={!template.haveGrid} onChange={handleGrid} color='primary' sx={{ '& .Mui-selected': { backgroundColor: 'primary.main', color: 'white' } }}>
                          <ToggleButton value="outer" key="outer"><BorderOuter /></ToggleButton>
                          <ToggleButton value="horizontal" key="horizontal"><BorderHorizontal /></ToggleButton>
                          <ToggleButton value="vertical" key="vertical"><BorderVertical /></ToggleButton>
                        </StyledToggleButtonGroup>
                      </Grid>
                      <Grid size={6}><Typography variant='body1'>Cor da grade </Typography></Grid>
                      <Grid size={6}><ColorInput format="hex" value={template.gridColor} onChange={(e) => setTemplate(prev => ({ ...prev, gridColor: e }))} /></Grid>
                    </Grid>
                  </AccordionDetails>
                </Accordion>
              </Grid>
            </Grid>
            </Box>
            <Box sx={{ display: 'flex', gap: 1, p: 1.5, pt: 1, flexShrink: 0 }}>
              <LoadingButton fullWidth color="success" variant="contained" onClick={handleSave}
                loading={isCreating || isUpdating}
                startIcon={<Save sx={{ marginRight: '3px' }} />}
              >Salvar</LoadingButton>
              <Button fullWidth color="primary" variant="contained" onClick={() => setOpenDialog(true)}>
                <Close sx={{ marginRight: '3px' }} />
                Cancelar
              </Button>
            </Box>
          </Box>
          <Divider orientation='vertical' />
          <Box id="display" sx={{ display: 'flex', flex: 8, ml: 1, alignItems: 'center', flexDirection: 'column', minHeight: 0 }}
            borderRadius={3}
          >
            <Grid container width={"100%"} sx={{ flexShrink: 0 }}>
              <Grid size={12} sx={{ display: 'flex', justifyContent: 'center' }}>
                <Typography variant='h2'>Pré-visualização</Typography>
              </Grid>
            </Grid >
            <Box sx={{ display: 'flex', flex: 1, minHeight: 0, width: '100%' }}>
              {selectedTable ?
                <TemplatePreView settings={template} priceTableId={selectedTable} />
                :
                <Box sx={{ height: "80%", display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <Typography>Selecione uma tabela de preço para visualizar o template</Typography>
                </Box>
              }
            </Box>
          </Box>

        </Box>
      </Box>
    </>
  )
}

export default TemplateEditPage